import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import TmeAdminHeader from "./TmeAdminHeader/TmeAdminHeader";
import { logoutCall } from "../util/userManager";
import "react-bootstrap-table/css/react-bootstrap-table.css";
import { connect } from "react-redux";
import { userActions } from "../actions";
import BlockUi from "react-block-ui";

class NmscUserEmailList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: this.props.loggedInUser.user.invoiceEmailInfoDTO.records,
      pageSize: 10,
      currentPage: 1,
      blocking: false,
      salesList: this.props.loggedInUser.user.invoiceEmailInfoDTO.emailInfoList,
    };
    this.logoutHandler = this.logoutHandler.bind(this);
    this.pageChanged = this.pageChanged.bind(this);
    this.emailPreference = this.emailPreference.bind(this);
  }

  emailPreference(cell) {
    if (cell === 1) {
      return <div> e-mail with a link to eDoc</div>;
    } else if (cell === 2) {
      return <div> e-mail with invoice as PDF attachment.</div>;
    }
  }

  pageChanged(pageNumber) {
    console.log("pageNumber=", pageNumber);
    this.setState({ currentPage: pageNumber });
    this.paginationHandler(
      pageNumber,
      this.state.pageSize,
      this.state.sortColumnName,
      this.state.sortOrder
    );
  }
  paginationHandler(pageNumber, pageSize, sortColumnName, sortOrder) {
    const { dispatch } = this.props;
    const reqBody = {
      size: pageSize ? pageSize : 10,
      index: pageNumber - 1,
      sortOrder: sortOrder,
      sortColumn: sortColumnName,
    };

    this.setState({ tabledata: [] });
    dispatch(userActions.searchEmail("/api/emailInfo", reqBody));
    this.setState({ salesList: this.props.data });
  }

  renderShowsTotal(start, to) {
    var text =
      "Showing " +
      start +
      " to " +
      to +
      " of " +
      this.state.records +
      " records.";
    return <p style={{ color: "#f02", fontSize: "12px" }}>{text}</p>;
  }

  sortChanged(sortColumn, order) {
    this.setState({ currentPage: 1 });
    let sortOrder = order.toString().toLowerCase() === "asc" ? "desc" : "asc";
    this.setState({ sortOrder: sortOrder });
    this.setState({ sortColumnName: sortColumn });

    this.paginationHandler(
      this.state.pageNumber,
      this.state.pageSize,
      this.state.sortColumnName,
      sortOrder
    );
  }

  sizePerPageListChange(sizePerPage) {
    this.setState({ pageSize: sizePerPage });
    this.paginationHandler(
      this.state.pageNumber,
      sizePerPage,
      this.state.sortColumnName,
      this.state.sortOrder
    );
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ blocking: nextProps.blocking });
    if (nextProps.emailData) {
      console.log("nextProps.EmailData", nextProps.emailData);
      this.setState({
        records: nextProps.emailData.records,
        salesList: nextProps.emailData.emailInfoList,
      });

      console.log(
        "this is the sales table list from nextProps",
        this.state.salesList
      );
    }
  }

  logoutHandler = (e) => {
    console.log(" logout call: ");
    e.preventDefault();
    logoutCall();
  };
  render() {
    console.log("this is Nmsc User Email props", this.props);
    const options = {
      //page: this.state.currentPage,
      sizePerPage: 10,
      prePage: "<",
      nextPage: ">",
      firstPage: "First",
      lastPage: "Last",
      onPageChange: this.pageChanged.bind(this),
      onSizePerPageList: this.sizePerPageListChange.bind(this),
      onSortChange: this.sortChanged.bind(this),
      paginationShowsTotal: this.renderShowsTotal.bind(this),
    };
    return (
      <BlockUi
        tag="div"
        blocking={this.state.blocking}
        message="Loading, please wait"
        keepInView
      >
        <div id="content" className="col-md-12 col-sm-12 col-xs-12">
          <TmeAdminHeader
            logoutUser={this.logoutHandler}
            username={this.props.loggedInUser.user.userName}
            roles={this.props.loggedInUser.user.roles}
            page={"PSCG TME Admin Screen"}
          />
          <div
            style={{
              marginTop: "0.5%",
              borderTop: "1px solid grey",
              // padding: "0.8rem",
              // background: "#FFFEFE",
              // border: "1px solid #E1D0D0",
              // boxShadow: "2px 2px 2px #ced4da",
              // borderRadius: "7px",
            }}
          >
            <span
              style={{
                fontSize: "20px",
                marginBottom: "2rem",
                marginTop: "1rem",
                fontStyle: "normal",
                marginLeft: "2rem",
                fontFamily: "Toyota Type",
                display: "block",
              }}
            >
              NMSC Users Email Information Portal
            </span>
            <div style={{ margin: "2.5%", marginTop: "2rem" }}>
              <BootstrapTable
                options={options}
                data={this.state.salesList}
                pagination={true}
                //selectRow={this.selectRowProp}
                bordered={true}
                striped={true}
                hover={true}
                remote={true}
                fetchInfo={{ dataTotalSize: this.state.records }}
              >
                <TableHeaderColumn
                  dataField="nmscCodeSupplierCode"
                  dataAlign="center"
                  isKey
                  dataSort={true}
                >
                  NMSC Code
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="nmscName"
                  dataAlign="center"
                  dataSort={true}
                >
                  NMSC NAME
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort={false}
                  dataFormat={this.emailPreference}
                  dataField="emailPreference"
                  dataAlign="center"
                >
                  Email Preference
                </TableHeaderColumn>
                <TableHeaderColumn
                  //dataSort={false}
                  dataField="emailTo"
                  dataAlign="center"
                >
                  Email Id
                </TableHeaderColumn>
              </BootstrapTable>

              {<p style={{ color: "black", marginLeft: "90px" }}></p>}
            </div>
          </div>
        </div>
      </BlockUi>
    );
  }
}

function mapStateToProps(state) {
  const { loggedInUser } = state.loginReducer;
  const { blocking } = state.searchData;
  const { emailData } = state.searchEmailData;

  return {
    loggedInUser,
    emailData,
    blocking,
  };
}

const ToyotaConnected = connect(mapStateToProps)(NmscUserEmailList);
export { ToyotaConnected as NmscUserEmailList };
